import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedEditionBlockchainCertView } from "./SignedEditionBlockchainCertView";
import { SignedEditionBlockchainCertViewStore } from "../../store/SignedEditionBlockchainCertViewStore";
import { useStore } from "../../../../hooks";

export const SignedEditionBlockchainCertViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/signedEditionBlockchainCert/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SignedEditionBlockchainCertViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SignedEditionBlockchainCertView
          signedEditionBlockchainCertViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
